/**
 * Determine if a string is null or empty
 *
 * @export
 * @param value
 */
export function isNullOrEmpty(value) {
	if (!value) {
		return true
	}
	
	if (value === null || value === undefined) {
		return true
	}

	let trimmed = value.trim()
	if (trimmed.length === 0) {
		return true
	}
	return false
}

/**
 * Determine is null or empty avatar
 * @param {*} value 
 */
export function isNullOrEmptyAvatar(value) {
	if (!value) {
		return true
	}
	
	if (value === null || value === undefined) {
		return true
	}

	let trimmed = value.trim()
	if (trimmed.length === 0) {
		return true
	}
	return false
}

/**
 * Determine if a string contains HTML markup (e.g. content produced by the rich text editor)
 * as opposed to legacy plain text.
 * Uses content-sniffing by design (simpler than a per-record creation-date cutoff): a legacy
 * plain-text value containing literal '<'/'>' (e.g. "revisar <pendiente>") can be misclassified
 * as HTML. Accepted trade-off.
 * @param {*} value
 */
export function containsHtmlContent(value) {
	if (isNullOrEmpty(value)) {
		return false
	}
	return /<\/?[a-z][\s\S]*>/i.test(value)
}

/**
 * Remove HTML tags from a string, leaving only its decoded text content.
 * Uses DOMParser instead of a regex so HTML entities (e.g. &nbsp;) are decoded too;
 * the parsed document is never attached to the live DOM, so it does not load
 * resources or execute scripts/event handlers.
 * @param {*} value
 */
export function stripHtmlTags(value) {
	if (isNullOrEmpty(value)) {
		return ''
	}
	const parsedDocument = new DOMParser().parseFromString(value, 'text/html')
	return parsedDocument.body.textContent || ''
}

export function isValidEmailFormat(emailString) {
	if (isNullOrEmpty(emailString)) {
		return true
	}
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	const emails = emailString.split(',').map((email) => email.trim())
	return emails.every((email) => {
		if (isNullOrEmpty(email)) {
			return false
		}
		return emailRegex.test(email)
	})
}